import {
  IIngredientDTO,
  IIngredientDocStockDTO,
  LiquidClassDTO,
  VendorDTO,
} from 'business/models/Models';
import { Input } from 'components/input';
import React from 'react';
import { StockPropsInputMap, StockTableData } from './utils/Constants';
import { isNullOrUndefined, padZeros } from 'utils/Global';
import { IOption } from 'components/input/selectInput';
import './stocks.css';

interface StockRowProps {
  stock: IIngredientDocStockDTO;
  onCellChanged: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    stockId: number,
  ) => void;
  liquidClasses: LiquidClassDTO[];
  vendors: VendorDTO[];
  ingInfo: IIngredientDTO;
  hasBufferType: boolean;
  concUnits: IOption[];
  hasNonBufferType: boolean;
}

export const StockRowRenderer = ({
  stock,
  onCellChanged,
  liquidClasses,
  vendors,
  ingInfo,
  hasBufferType,
  concUnits,
  hasNonBufferType,
}: StockRowProps) => {
  const stockPropsMap: StockPropsInputMap = {
    active: { type: 'checkbox' },
    id: { type: 'number', disabled: true },
    stockNumber: {
      type: 'number',
      value: padZeros(stock.stockNumber, 4),
      disabled: true,
    },
    stockConcentration: { type: 'number', disabled: stock.isUsed },
    concentrationUnits: { type: 'select', options: concUnits, disabled: stock.isUsed },
    lowConcentration: { type: 'number' },
    highConcentration: { type: 'number' },
    liquidClassId: {
      type: 'select',
      options: liquidClasses.map((val) => {
        return { title: val.name, value: val.id };
      }),
    },
    isBuffer: {
      type: 'checkbox',
      disabled: !hasBufferType || stock.id === ingInfo.defaultNonBufferIngredientStockId,
    },
    stockPh: { type: 'number', disabled: stock.isUsed },
    vendorId: {
      type: 'select',
      options: vendors.map((val) => {
        return { title: val.name, value: val.id };
      }),
    },
    vendorPartNumber: { type: 'text' },
    dispenseOrder: { type: 'text' },
    bufferDefault: {
      type: 'checkbox',
      disabled: !hasBufferType,
      value: stock.id === ingInfo.defaultBufferIngredientStockId,
    },
    nonBufferDefault: {
      type: 'checkbox',
      disabled: !hasNonBufferType,
      value: stock.id === ingInfo.defaultNonBufferIngredientStockId,
    },
    isPrepared: { type: 'checkbox' },
    stockLocation: { type: 'text' },
  } as StockPropsInputMap;

  const rowData: StockTableData = {};

  const clickHandler = (e) => {
    e.stopPropagation();
  };

  Object.keys(stockPropsMap).forEach((key) => {
    const prop = stockPropsMap[key];
    rowData[key] = (
      <Input
        id={`stockrowrenderer-${key}`}
        name={key}
        className={
          prop.type !== 'checkbox' &&
          `w-full border-none bg-transparent h-8 rm-input-number alignContent overflow-eclipse`
        }
        onChange={(e) => onCellChanged(e, stock.id)}
        value={
          key === 'id'
            ? stock[key] < 0
              ? 0
              : stock[key]
            : !isNullOrUndefined(prop.value)
            ? prop.value
            : stock[key]
        }
        inputType={prop.type}
        options={prop.options}
        disabled={prop.disabled}
        checked={
          prop.type === 'checkbox' &&
          (!isNullOrUndefined(prop.value) ? prop.value : stock[key])
        }
        containerStyle={{ width: '100%' }}
        onClick={clickHandler}
        title={!isNullOrUndefined(prop.value) ? prop.value : stock[key]}
      />
    );
  });
  return rowData;
};
